/**
 * Lista de canciones — /songs
 */

import { For } from "solid-js";
import { createRoute, Link } from "@tanstack/solid-router";
import { ArrowLeft, Music } from "@fleet/icons";
import { msg } from "@lingui/core/macro";
import { SONGS } from "@melodimals/game-core";
import { rootRoute } from "@/routes/__root";
import { useI18n } from "@/providers/i18n-provider";

const CARD_COLORS = [
  "bg-joy-coral",
  "bg-joy-tangerine",
  "bg-joy-sunshine",
  "bg-joy-mint",
  "bg-joy-grass",
  "bg-joy-sky",
  "bg-joy-grape",
  "bg-joy-bubblegum",
];

function SongsPage() {
  const { t } = useI18n();

  return (
    <main class="kid-stage-screen screen-enter bg-background p-4">
      <header class="flex items-center gap-3 pb-3">
        <Link
          to="/"
          class="tile-3d tile-3d-press flex h-14 w-14 items-center justify-center rounded-full bg-surface"
          aria-label={t(msg`Back`)}
        >
          <ArrowLeft class="h-7 w-7 text-foreground" />
        </Link>
      </header>
      <div class="min-h-0 flex-1 overflow-y-auto">
        <div class="grid grid-cols-2 gap-4 pb-4 sm:grid-cols-3 lg:grid-cols-4">
          <For each={SONGS}>
            {(song, i) => (
              <Link
                to="/songs/$songId"
                params={{ songId: song.id }}
                style={{ "animation-delay": `${i() * 50}ms` }}
                class={`tile-3d tile-3d-press animate-pop-in flex min-h-36 flex-col items-center justify-center gap-3 rounded-[1.75rem] p-3 text-center select-none ${CARD_COLORS[i() % CARD_COLORS.length]}`}
              >
                {/* Icon + title sit on opaque chips so they stay legible on
                    every joy tint (dark coral/grape as well as light sunshine). */}
                <span class="flex h-14 w-14 items-center justify-center rounded-full bg-white/85 shadow-sm">
                  <Music class="h-7 w-7 text-zinc-700" aria-hidden="true" />
                </span>
                <span class="rounded-full bg-white/85 px-3 py-1 text-base font-bold leading-tight text-zinc-800 shadow-sm">
                  {song.title}
                </span>
              </Link>
            )}
          </For>
        </div>
      </div>
    </main>
  );
}

export const songsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/songs",
  component: SongsPage,
});
